"use client";

import { useTranslations } from "next-intl";

export const OrdersEmptyState = () => {
  const t = useTranslations("orders");
  return (
    <div className="flex items-center justify-center py-17.5">
      <p className="text-text-secondary text-base font-medium">
        {t("empty.noOrders")}
      </p>
    </div>
  );
};
